// import React, { useEffect } from 'react';
import React, { useState, useEffect } from "react";
// import './i18n.js'; 						// Only once, initializes i18next
import ReactDOM from 'react-dom/client';
import { Provider } from 'mobx-react';
import { globalStores } from './stores/index.js';

import 'bootstrap/dist/css/bootstrap.css';
import './styles/style.css';
import './styles/style.scss';

import sonicImage from './assets/sonic.png';

import App from './App.js';


// import BorderWrapper from './fireComponents/BorderWrapper.js';
// import ScrollToTop from './fireComponents/ScrollToTop.js'; // adjust the path as needed

// // import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';		// Used for Server-Side Routing
// import { HashRouter as Router, Routes, Route } from 'react-router-dom';			// Used for Client-Side Routing

// import { Layout } from './components/Layout.js';
// import Home from './pages/Home.js'
// import Services from './pages/Services.js'
// import Service1 from './pages/Service1.js'
// import Service2 from './pages/Service2.js'
// import Service3 from './pages/Service3.js'
// import Pricing from './pages/Pricing.js'
// import About from './pages/About.js'
// import Values from './pages/Values.js'
// import Gallery from './pages/Gallery.js'
// import FAQ from './pages/FAQ.js'
// import Contact_Pigeon from './pages/Contact_Pigeon.js'
// import Contact_Google from './pages/Contact_Google.js';
// import Booking from './pages/Booking.js'


const mode = 'development';

// Set up the logging mode
window.log = mode === 'development' ? console.log.bind(console) : () => {};

////////////
// OPTION 1
////////////
// // Create the root div element and add it to the body
// const rootElement = document.createElement('div');
// rootElement.id = 'app-root';
// document.body.appendChild(rootElement); // Appends the root div to the body

// // Create the React root using ReactDOM.createRoot
// const root = ReactDOM.createRoot(rootElement);  // Use createRoot to initialize the React root

// // color box spinner
// const preloadTest = (
// 	<div className="loader-wrapper">			
// 		<div className="spinner-wrapper">
// 			<div className="spinner-text">Loading...</div>	
// 			<div className="spinner-img"><img
// 				src={sonicImage}
//         className="logo-image-head"/></div>
// 		</div>
// 	</div>
// );

// const myAppTree = (
// 	<Provider {...globalStores}>
// 		<App />
// 	</Provider>
// );

// const myAppTree = (
// 	// <Provider>
// 	<Provider {...stores}>
// 		{/* <BorderWrapper> */}
// 			<Router>
// 				<ScrollToTop />
// 				<Routes>
// 					<Route element={<Layout />}>
// 						<Route path="/" element={<Home />} />
// 						<Route path="/services" element={<Services />} />
// 						<Route path="/services/service1" element={<Service1 />} />
// 						<Route path="/services/service2" element={<Service2 />} />
// 						<Route path="/services/service3" element={<Service3 />} />
// 						<Route path="/pricing" element={<Pricing />} />
// 						<Route path="/about" element={<About />} />
// 						<Route path="/values" element={<Values />} />
// 						<Route path="/gallery" element={<Gallery />} />
// 						<Route path="/faq" element={<FAQ />} />
// 						{/* <Route path="/contact-p" element={<Contact_Pigeon />} /> */}
// 						<Route path="/contact" element={<Contact_Google />} />
// 						<Route path="/booking" element={<Booking />} />
// 					</Route>
// 				</Routes>
// 			</Router>
// 		{/* </BorderWrapper> */}
// 	</Provider>
// );

// // Option 1: Render the spinner, then render the app after __ms
// root.render(preloadTest);
// setTimeout(() => {
//   root.render(myAppTree);
// }, 50);

// // Option 2: Render without the spinner
// root.render(myAppTree);


////////////
// OPTION 2
////////////
// const Root = () => {
//   // Force re-render on HMR updates
//   const [, forceRender] = useState(0);

//   useEffect(() => {
//     if (import.meta.hot) {
//       import.meta.hot.accept(() => {
//         forceRender(x => x + 1);
//       });
//     }
//   }, []);

//   // Render your app normally inside the Provider
//   return <Provider {...globalStores}><App /></Provider>;
// };
// // Create root div
// const rootElement = document.createElement("div");
// rootElement.id = "app-root";
// document.body.appendChild(rootElement);

// // Render
// const root = ReactDOM.createRoot(rootElement);
// root.render(<Root />);


// ////////////
// // OPTION 3
// ////////////
// const Root = () => {
//   // No need to force re-render — we’ll full reload instead
//   return (
//     <Provider {...globalStores}>
//       <App />
//     </Provider>
//   );
// };

// // Create root div dynamically
// const rootElement = document.createElement("div");
// rootElement.id = "app-root";
// document.body.appendChild(rootElement);

// // Mount React app
// const root = ReactDOM.createRoot(rootElement);
// root.render(<Root />);

// // Force full page reload on HMR update (Webpack only)
// if (module.hot) {
//   let timeout;
//   module.hot.accept(() => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => {
//       console.warn("♻️ Hot reload detected — reloading entire page to clear memory leaks.");
//       window.location.reload();
//     }, 300);
//   });
// }


////////////
// OPTION 4
////////////
const Root = () => {
  // No need to force re-render — we’ll full reload instead
  return (
    <Provider {...globalStores}>
      <App />
    </Provider>
  );
};

// Create root div dynamically
const rootElement = document.createElement("div");
rootElement.id = "app-root";
document.body.appendChild(rootElement);

// Mount React app
const root = ReactDOM.createRoot(rootElement);
root.render(<Root />);
